import React from 'react';

/**
 * Aviso exibido quando o usuário alterou filtros do Painel de Controle mas
 * ainda não clicou em "Realizar Consulta". Compartilhado por GraficoSH,
 * GraficoSM e TabelaComparativoSM para manter o mesmo texto/estilo nas três
 * visões (WEOL-SH semi/diário, WEOL-SM Semanal e Comparativo).
 *
 * Markup idêntico ao bloco que existia inline em GraficoSH/GraficoSM —
 * extração não muda nada visualmente.
 */
export default function AvisoFiltrosAlterados() {
  return (
    <div className="mt-4 p-4 border rounded text-muted text-center">
      Filtros alterados. Clique em
      {' '}
      <strong>Realizar Consulta</strong>
      {' '}
      para atualizar.
    </div>
  );
}
